import React from "react";
import { formatDate } from "../utils";
import { t } from "i18next"; // Import t function for translation

const UserRewardListItem = (props) => {
  const { data } = props || {};

  return (
    <div className="user-reward-list-item">
      <div className="user-reward-list-item-image">
        <img src={data?.rewardImage} className="img-fluid" alt="LG" />
      </div>
      <div className="user-reward-list-item-context">
        <div className="user-reward-list-item-context-title">
          {data?.rewardName}
        </div>
        <div className="user-reward-list-item-context-global">
          <div className="user-reward-list-item-context-global-date">
            {t("userRewardListItem.sentTitle")}: {formatDate(data?.createdAt)}
          </div>
          <div className="user-reward-list-item-context-global-date">
            {t("userRewardListItem.qty")}: {data?.quantity ? data?.quantity : 1}
          </div>
          <div className="user-reward-list-item-context-global-points">
            {t("userRewardListItem.totalPointsTitle")}: &nbsp;
            <span>
              {data?.points} {t("userRewardListItem.points")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRewardListItem;
